import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Layout from './components/layout/Layout';
import DashboardPage from './pages/DashboardPage';
import JamaahListPage from './pages/JamaahListPage';
import TambahJamaahPage from './pages/TambahJamaahPage';

// Import CSS jika diperlukan
// import './App.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          {/* Rute Utama */}
          <Route path="/" element={<DashboardPage />} />
          
          {/* Rute Jamaah */}
          <Route path="/jamaah" element={<JamaahListPage />} />
          <Route path="/jamaah/tambah" element={<TambahJamaahPage />} />
          {/* Rute detail jamaah akan ditambahkan di masa mendatang */}
          <Route path="/jamaah/:id" element={<div>Detail Jamaah (Coming Soon)</div>} />
          <Route path="/jamaah/edit/:id" element={<div>Edit Jamaah (Coming Soon)</div>} />
          
          {/* Rute Paket Umroh */}
          <Route path="/paket" element={<div>Paket Umroh (Coming Soon)</div>} />
          <Route path="/paket/:id" element={<div>Detail Paket (Coming Soon)</div>} />
          
          {/* Rute Pembayaran */}
          <Route path="/pembayaran" element={<div>Pembayaran (Coming Soon)</div>} />
          
          {/* Rute Laporan */}
          <Route path="/laporan" element={<div>Laporan (Coming Soon)</div>} />
          
          {/* Rute Pengaturan */}
          <Route path="/pengaturan" element={<div>Pengaturan (Coming Soon)</div>} />
          
          {/* Rute 404 - Not Found */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;